"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addMembersToGroup = exports.cancelRequest = exports.leaveGroup = exports.requestJoinGroup = exports.joinGroup = exports.listMemberAnswers = void 0;
const constants_1 = require("../constants");
function listMemberAnswers({ groupId, memberId, }) {
    return {
        method: 'GET',
        url: `/${constants_1.serverlessBaseURL}/group/${groupId}/members/${memberId}/answers`,
    };
}
exports.listMemberAnswers = listMemberAnswers;
function joinGroup({ groupId, ...data }) {
    return {
        data,
        method: 'POST',
        url: `/${constants_1.serverlessBaseURL}/group/${groupId}/members/join`,
    };
}
exports.joinGroup = joinGroup;
function requestJoinGroup({ groupId, ...data }) {
    return {
        method: 'POST',
        data,
        url: `/${constants_1.serverlessBaseURL}/group/${groupId}/members/request-join`,
    };
}
exports.requestJoinGroup = requestJoinGroup;
function leaveGroup({ groupId, }) {
    return {
        method: 'POST',
        url: `/${constants_1.serverlessBaseURL}/group/${groupId}/members/leave`,
    };
}
exports.leaveGroup = leaveGroup;
function cancelRequest({ groupId, }) {
    return {
        method: 'POST',
        url: `/${constants_1.serverlessBaseURL}/group/${groupId}/members/cancel-request`,
    };
}
exports.cancelRequest = cancelRequest;
function addMembersToGroup(params) {
    return {
        method: 'POST',
        data: params,
        url: `/${constants_1.serverlessBaseURL}/group/${params.groupId}/members/add-members`,
    };
}
exports.addMembersToGroup = addMembersToGroup;
//# sourceMappingURL=http.js.map